// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__208nV","selected":"Chip_selected__Y-ky9"};